import React, {Fragment, useCallback, useMemo} from "react"
import classNames from "classnames"
import useLevels from "hooks/useLevels"
import useValues from "hooks/useValues"
import {getCurrentSeason} from "utils/date_utils"
import "./RescuerLevels.css"

export default function RescuerLevels(props) {
    
    const {username} = props
    const {levels} = useLevels(username)
    const {data: values} = useValues('values')
    
    const levelMap = useMemo(() => {
        if (!levels) return {}
        return Object.fromEntries(levels.map(i => [i.domain, i.level]))
    }, [levels])
    
    
    const getTitle = useCallback(level => {
        const filtered = values.levels.filter(lev => lev.id == level)
        if (filtered.length > 0) return filtered[0].title
        return "-"
    }, [values])
    
    if (!levels || !values?.levels || !values?.domains) return
    
    return <div id="rescuer-levels">
        <b>Zvanja</b>
        
        {Object.entries(values.domains).map(([key, value]) => <div key={key} className="domain">
            {value}: {getTitle(levelMap[key])}
        </div>)}
    </div>

}